import React, { useState, useEffect } from "react";
import axios, { renderDoc } from "../Axiosinstance";
import {
  TextField,
  Button,
  Grid,
  CircularProgress,
  Slide,
  Typography,
  Container,
  MenuItem,
  Modal,
  Box,
  TableContainer,
  Select,
  InputLabel,
  FormControl,
  IconButton,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  RadioGroup,
  FormControlLabel,
  Radio, Autocomplete,
  Card,
  CardContent,
  Tooltip,
  Table,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  Menu,
  Snackbar,
  Alert,
} from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import { Navigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Upload } from "@mui/icons-material";
import { buttonBackgroundColor, logoImage, validateIdentityNumbers } from "../common";
import { useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { InputAdornment } from '@mui/material';
import LinearProgress from "@mui/material/LinearProgress";
import "../All/registration.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PhoneInput from "react-phone-input-2";
// import 'react-phone-input-2/lib/style.css'
import { removeBracketedText } from "../Axiosinstance";
// import { GetCountries } from "react-country-state-city";
import { Country as CountryData } from 'country-state-city';
import dayjs from 'dayjs';
import * as pdfjs from "pdfjs-dist/build/pdf";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";
import * as pdfjsLib from "pdfjs-dist";
import "pdfjs-dist/build/pdf.worker.entry";

pdfjs.GlobalWorkerOptions.workerSrc = pdfWorker;


const NewStudent = () => {
  // const { batchId, startDate, currentModule, type } = useState();
  const [paymentSessionUrl, setPaymentSessionUrl] = useState("");
  const [editedStudent, setEditedStudent] = useState(false);
  const [dataResponse, setDataResponse] = useState([]);
  const [fetchedOrNot, setFetchedOrNot] = useState(false);
  const navigate = useNavigate();
  const [dialogClass, setDialogClass] = useState("");
  const [submissionSuccess, setSubmissionSuccess] = useState(false);
  const [batchSummary, setBatchSummary] = useState([]);
  const [selectedBatchId, setSelectedBatchId] = useState("");
  const [initialDate, setInitialDate] = useState(null);
  const [initialModulus, setInitialModulus] = useState(0);
  const [selectedBatch, setSelectedBatch] = useState([]);
  const [loadingButton, setLoadingButton] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [countryBirthValid, setCountryBirthValid] = useState(true);
  const [nationalityValid, setNationalityValid] = useState(true);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    axios
      .get("/batch-summary")
      .then((response) => {
        setBatchSummary(response.data);
        console.log(response.data, "batchsummary");
      })
      .catch((error) => console.error("Error fetching batch summary:", error));
  }, []);

  const [errors, setErrors] = useState({
    workPermitSpass: false,
  });

  const [formData, setFormData] = useState({
    studentName: "",
    studentEmail: "",
    batchId: "",
    startModulus: "",
    enrollmentDate: "",
    nric: "",
    proofType: "",
    phone: "",
    email: "",
    gender: "",
    dob: "",
    password: "",
    type: "",
    sureName: "",
    countryBirth: "",
    nationality: "",
    NRICno: "",
    passportNo: "",
    addressOffice: "",
    addressHome: "",
    phoneOffice: "",
    phoneHome: "",
    handPhone: "",
    emergencyName: "",
    emergencyRelation: "",
    emergencyPhone: "",
    knowAboutProgram: "",
    applicationSignature: "",
    emergencyOtherDetails: "",
    nonSingaporean: "",
    company: "",
    photo: "",
    approve: "false",
    sessionId: null,
    sessionIdDate: null,

    paymentStatus: "Pending",
    // paymentType: "online",
    institutionDetails: [],

    workPermitSpass: "",
    workPermitOne: "",
    repass: "",
    dependentPass: "",
    passport: "",
    markSheet: {
      level1: "",
    },
    certificate: {
      level1: "",
    },
    transcript: "",
    profilePicture: "",
    workPermitSpassProgress: 0,
    workPermitSpassStatus: "",
    workPermitOneProgress: 0,
    workPermitOneStatus: "",
    transcriptProgress: 0,
    transcriptStatus: "",
    passportProgress: 0,
    passportStatus: "",
    profilePictureProgress: 0,
    profilePictureStatus: "",
    workPermitSpassUrl: "",
    workPermitOneUrl: "",
    transcriptUrl: "",
    passportUrl: "",
    profilePictureUrl: "",
    otherDetails: "",
    markSheetFileNames: {},
    certificateFileNames: {},
    workPermitSpassFileName: "",
    workPermitOneFileName: "",
    passportFileName: "",
    profilePictureFileName: "",
    referalfriend: "",
  });

  const [countriesList, setCountriesList] = useState([]);

  // useEffect(() => {

  //   GetCountries().then((result) => {
  //     setCountriesList(result);
  //   });
  // }, []);

  useEffect(() => {
    const countries = CountryData.getAllCountries();
    setCountriesList(countries);
  }, []);

  const nationalityMapping = {
    Afghanistan: "Afghan",
    Albania: "Albanian",
    Algeria: "Algerian",
    Andorra: "Andorran",
    Angola: "Angolan",
    "Antigua and Barbuda": "Antiguan or Barbudan",
    Argentina: "Argentine",
    Armenia: "Armenian",
    Australia: "Australian",
    Austria: "Austrian",
    Azerbaijan: "Azerbaijani",
    Bahamas: "Bahamian",
    Bahrain: "Bahraini",
    Bangladesh: "Bangladeshi",
    Barbados: "Barbadian",
    Belarus: "Belarusian",
    Belgium: "Belgian",
    Belize: "Belizean",
    Benin: "Beninese",
    Bhutan: "Bhutanese",
    Bolivia: "Bolivian",
    "Bosnia and Herzegovina": "Bosnian",
    Botswana: "Botswana",
    Brazil: "Brazilian",
    Brunei: "Bruneian",
    Bulgaria: "Bulgarian",
    "Burkina Faso": "Burkinabé",
    Burundi: "Burundian",
    "Cabo Verde": "Cape Verdean",
    Cambodia: "Cambodian",
    Cameroon: "Cameroonian",
    Canada: "Canadian",
    "Central African Republic": "Central African",
    Chad: "Chadian",
    Chile: "Chilean",
    China: "Chinese",
    Colombia: "Colombian",
    Comoros: "Comorian",
    Congo: "Congolese",
    "Congo, Democratic Republic of the": "Congolese",
    "Costa Rica": "Costa Rican",
    Croatia: "Croatian",
    Cuba: "Cuban",
    Cyprus: "Cypriot",
    "Czech Republic": "Czech",
    Denmark: "Danish",
    Djibouti: "Djiboutian",
    Dominica: "Dominican",
    "Dominican Republic": "Dominican",
    Ecuador: "Ecuadorian",
    Egypt: "Egyptian",
    "El Salvador": "Salvadoran",
    "Equatorial Guinea": "Equatorial Guinean",
    Eritrea: "Eritrean",
    Estonia: "Estonian",
    Eswatini: "Swazi",
    Ethiopia: "Ethiopian",
    Fiji: "Fijian",
    Finland: "Finnish",
    France: "French",
    Gabon: "Gabonese",
    Gambia: "Gambian",
    Georgia: "Georgian",
    Germany: "German",
    Ghana: "Ghanaian",
    Greece: "Greek",
    Grenada: "Grenadian",
    Guatemala: "Guatemalan",
    Guinea: "Guinean",
    "Guinea-Bissau": "Guinean",
    Guyana: "Guyanese",
    Haiti: "Haitian",
    Honduras: "Honduran",
    Hungary: "Hungarian",
    Iceland: "Icelandic",
    India: "Indian",
    Indonesia: "Indonesian",
    Iran: "Iranian",
    Iraq: "Iraqi",
    Ireland: "Irish",
    Israel: "Israeli",
    Italy: "Italian",
    Jamaica: "Jamaican",
    Japan: "Japanese",
    Jordan: "Jordanian",
    Kazakhstan: "Kazakh",
    Kenya: "Kenyan",
    Kiribati: "I-Kiribati",
    "Korea, North": "North Korean",
    "Korea, South": "South Korean",
    Kosovo: "Kosovar",
    Kuwait: "Kuwaiti",
    Kyrgyzstan: "Kyrgyz",
    Laos: "Laotian",
    Latvia: "Latvian",
    Lebanon: "Lebanese",
    Lesotho: "Lesotho",
    Liberia: "Liberian",
    Libya: "Libyan",
    Liechtenstein: "Liechtensteiner",
    Lithuania: "Lithuanian",
    Luxembourg: "Luxembourgish",
    Madagascar: "Malagasy",
    Malawi: "Malawian",
    Malaysia: "Malaysian",
    Maldives: "Maldivian",
    Mali: "Malian",
    Malta: "Maltese",
    "Marshall Islands": "Marshallese",
    Mauritania: "Mauritanian",
    Mauritius: "Mauritian",
    Mexico: "Mexican",
    Micronesia: "Micronesian",
    Moldova: "Moldovan",
    Monaco: "Monacan",
    Mongolia: "Mongolian",
    Montenegro: "Montenegrin",
    Morocco: "Moroccan",
    Mozambique: "Mozambican",
    Myanmar: "Burmese",
    Namibia: "Namibian",
    Nauru: "Nauruan",
    Nepal: "Nepali",
    Netherlands: "Dutch",
    "New Zealand": "New Zealander",
    Nicaragua: "Nicaraguan",
    Niger: "Nigerien",
    Nigeria: "Nigerian",
    "North Macedonia": "Macedonian",
    Norway: "Norwegian",
    Oman: "Omani",
    Pakistan: "Pakistani",
    Palau: "Palauan",
    Palestine: "Palestinian",
    Panama: "Panamanian",
    "Papua New Guinea": "Papua New Guinean",
    Paraguay: "Paraguayan",
    Peru: "Peruvian",
    Philippines: "Filipino",
    Poland: "Polish",
    Portugal: "Portuguese",
    Qatar: "Qatari",
    Romania: "Romanian",
    Russia: "Russian",
    Rwanda: "Rwandan",
    "Saint Kitts and Nevis": "Kittian or Nevisian",
    "Saint Lucia": "Saint Lucian",
    "Saint Vincent and the Grenadines": "Vincentian",
    Samoa: "Samoan",
    "San Marino": "Sammarinese",
    "Sao Tome and Principe": "Sao Tomean",
    "Saudi Arabia": "Saudi",
    Senegal: "Senegalese",
    Serbia: "Serbian",
    Seychelles: "Seychellois",
    "Sierra Leone": "Sierra Leonean",
    Singapore: "Singaporean",
    Slovakia: "Slovak",
    Slovenia: "Slovenian",
    "Solomon Islands": "Solomon Islander",
    Somalia: "Somali",
    "South Africa": "South African",
    "South Sudan": "South Sudanese",
    Spain: "Spanish",
    "Sri Lanka": "Sri Lankan",
    Sudan: "Sudanese",
    Suriname: "Surinamese",
    Sweden: "Swedish",
    Switzerland: "Swiss",
    Syria: "Syrian",
    Taiwan: "Taiwanese",
    Tajikistan: "Tajik",
    Tanzania: "Tanzanian",
    Thailand: "Thai",
    "Timor-Leste": "Timorese",
    Togo: "Togolese",
    Tonga: "Tongan",
    "Trinidad and Tobago": "Trinidadian or Tobagonian",
    Tunisia: "Tunisian",
    Turkey: "Turkish",
    Turkmenistan: "Turkmen",
    Tuvalu: "Tuvaluan",
    Uganda: "Ugandan",
    Ukraine: "Ukrainian",
    "United Arab Emirates": "Emirati",
    "United Kingdom": "British",
    "United States": "American",
    Uruguay: "Uruguayan",
    Uzbekistan: "Uzbek",
    Vanuatu: "Ni-Vanuatu",
    "Vatican City": "Vatican",
    Venezuela: "Venezuelan",
    Vietnam: "Vietnamese",
    Yemen: "Yemeni",
    Zambia: "Zambian",
    Zimbabwe: "Zimbabwean",
    "Aland Islands": "Alandic",
    "American Samoa": "American Samoan",
    Anguilla: "Anguillian",
    "Antigua and Barbuda": "Antiguan and Barbudan",
    Aruba: "Aruban",
    Bermuda: "Bermudian",
    "Bonaire, Sint Eustatius and Saba": "Dutch Caribbean",
    "Bouvet Island": "Norwegian",
    "British Indian Ocean Territory": "British",
    "Cape Verde": "Cape Verdean",
    "Cayman Islands": "Caymanian",
    "Christmas Island": "Australian",
    "Cocos (Keeling) Islands": "Australian",
    "Cook Islands": "Cook Islander",
    "Cote d'Ivoire (Ivory Coast)": "Ivorian",
    Curaçao: "Curacaon",
    "Democratic Republic of the Congo": "Congolese",
    "East Timor": "Timorese",
    "Falkland Islands": "Falklander or British",
    "Faroe Islands": "Faroese",
    "Fiji Islands": "Fijian",
    "French Guiana": "French Guianese",
    "French Polynesia": "French Polynesian",
    "French Southern Territories": "French",
    "Gambia, The": "Gambian",
    Gibraltar: "Gibraltarian",
    Greenland: "Greenlandic or Danish",
    Guadeloupe: "Guadeloupean or French",
    Guam: "Guamanian or American",
    "Guernsey and Alderney": "Guernsey and Alderney (Channel Islander)",
    "Heard Island and McDonald Islands": "Australian",
    "Hong Kong S.A.R.": "Hongkonger",
    Jersey: "Jersey (Channel Islander)",
    "Macau S.A.R.": "Macanese",
    Macedonia: "Macedonian",
    "Man (Isle of)": "Manx",
    Martinique: "Martiniquais",
    Mayotte: "Mahoran",
    Montserrat: "Montserratian",
    "New Caledonia": "New Caledonian",
    Niue: "Niuean",
    "Norfolk Island": "Norfolk Islander",
    "North Korea": "North Korean",
    "Northern Mariana Islands": "Northern Marianan or American",
    "Palestinian Territory Occupied": "Palestinian",
    "Papua New Guinea": "Papua New Guinean",
    "Pitcairn Island": "Pitcairn Islander",
    "Puerto Rico": "Puerto Rican",
    Réunion: "Réunionese or French",
    "Saint Helena": "Saint Helenian",
    "Saint Kitts and Nevis": "Kittitian or Nevisian",
    "Saint Pierre and Miquelon": "Saint-Pierrais or Miquelonnais",
    "Saint Vincent and the Grenadines": "Vincentian",
    "Saint-Barthélemy": "Saint-Barthélemy (French)",
    "Saint-Martin (French part)": "Saint-Martinois (French)",
    "Sint Maarten (Dutch part)": "Sint Maartener",
    "South Georgia": "British",
    "South Korea": "South Korean",
    "Svalbard and Jan Mayen Islands": "Svalbardian or Norwegian",
    Swaziland: "Swazi",
    "The Bahamas": "Bahamian",
    Tokelau: "Tokelauan",
    "Trinidad and Tobago": "Trinidadian or Tobagonian",
    "Turks and Caicos Islands": "Turks and Caicos Islander",
    "United States Minor Outlying Islands": "American",
    "Vatican City State (Holy See)": "Vatican or Papal",
    "Virgin Islands (British)": "British Virgin Islander",
    "Virgin Islands (US)": "American Virgin Islander",
    "Wallis and Futuna Islands": "Wallisian or Futunan",
    "Western Sahara": "Sahrawi",
    "Antigua and Barbuda": "Antiguan and Barbudan",
    "Cote d'Ivoire (Ivory Coast)": "Ivorian",
    "Gambia, The": "Gambian",
    "Papua New Guinea": "Papua New Guinean",
    Réunion: "Réunionese or French",
    "Saint Kitts and Nevis": "Kittitian or Nevisian",
    "Saint Vincent and the Grenadines": "Vincentian",
    "Saint-Barthélemy": "Saint-Barthélemy (French)",
    "Svalbard and Jan Mayen Islands": "Svalbardian or Norwegian",
    "Trinidad and Tobago": "Trinidadian or Tobagonian",
    "Turks and Caicos Islands": "Turks and Caicos Islander",
    "Wallis and Futuna Islands": "Wallisian or Futunan",
  };

  const prioritizeCountries = (countriesList) => {
    // Define the priority countries with specific order
    const priorityCountries = ["Singapore", "Malaysia", "India"];

    // Separate priority and non-priority countries
    const priorityList = countriesList
      .filter((country) => priorityCountries.includes(country.name))
      .sort(
        (a, b) =>
          priorityCountries.indexOf(a.name) - priorityCountries.indexOf(b.name)
      );

    const nonPriorityList = countriesList.filter(
      (country) => !priorityCountries.includes(country.name)
    );

    // Concatenate priority and non-priority lists
    return [...priorityList, ...nonPriorityList];
  };

  const prioritizedCountriesList = prioritizeCountries(countriesList);

  const [open, setOpen] = useState(false);

  const [page, setPage] = useState(0); // Assuming you're using page state to handle form steps

  const goToNextPage = () => {
    setPage((prevPage) => prevPage + 1); // Increment the page to move to the next step
  };
  // const [paymentMethod, setPaymentMethod] = useState('');
  // const [studentDetails, setStudentDetails] = useState({ name: '', studentId: '' });

  const [alreadyRegistered, setAlreadyRegistered] = useState(false);
  // const [unpaid, setUnpaid] = useState(false);

  // const [registrationAdvance, setRegistrationadvance] = useState({ id: '' });
  // const [anchorEl, setAnchorEl] = useState(null);

  // const [disableInputs, setDisableInputs] = useState(false);

  const SUPPORTED_FILE_TYPES = {
    profilePicture: ["image/jpeg", "image/png", "image/jpg"],
    general: [
      "image/jpeg",
      "image/png",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ],
  };


  const CLOUDINARY_URL = "https://api.cloudinary.com/v1_1/dyjwwi8ea/raw/upload";
  const CLOUDINARY_UPLOAD_PRESET = "vldqgwk8";

  const handleFileUpload = async (event, docType, index = null) => {
    const file = event.target.files[0];
    if (!file) return;

    // Allowed file types for normal uploads
    const SUPPORTED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];

    if (!SUPPORTED_FILE_TYPES.includes(file.type)) {
      toast.error('Error: Unsupported file type! Please upload a .jpg, .jpeg, .png, or .pdf file.', {
        style: {
          backgroundColor: '#fff',
          color: 'black',
          fontWeight: 'normal',
        }
      });

      if (docType.startsWith("markSheet") || docType.startsWith("certificate")) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [docType.startsWith("markSheet") ? "markSheet" : "certificate"]: {
            ...prevFormData[docType.startsWith("markSheet") ? "markSheet" : "certificate"],
            [`level${index + 1}Status`]: 'Error: Unsupported file type',
            [`level${index + 1}Progress`]: 0,
          },
          [docType.startsWith("markSheet") ? "markSheetFileNames" : "certificateFileNames"]: {
            ...prevFormData[docType.startsWith("markSheet") ? "markSheetFileNames" : "certificateFileNames"],
            [`level${index + 1}`]: '',
          }
        }));
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [`${docType}Status`]: 'Error: Unsupported file type',
          [`${docType}Progress`]: 0,
          [`${docType}FileName`]: '',
        }));
      }

      return;
    }

    // If the file is a PDF and docType is profilePicture, convert to JPG
    if (file.type === 'application/pdf' && docType === 'profilePicture') {
      try {
        const firstPageJpgBlob = await convertPdfToJpg(file);
        const jpgFile = new File([firstPageJpgBlob], "converted-profile.jpg", { type: "image/jpeg" });

        // Upload the converted JPG file
        await uploadFile(jpgFile, docType, index);
      } catch (error) {
        console.error("Error converting PDF to JPG:", error);
        toast.error('Error converting PDF. Please try again.');
      }
    } else {
      // Upload normal file (JPG, PNG, etc.)
      await uploadFile(file, docType, index);
    }
  };

  // Function to upload file to Cloudinary
  const uploadFile = async (file, docType, index = null) => {
    setLoadingButton(docType);
    const uploadFormData = new FormData();
    uploadFormData.append('file', file);
    uploadFormData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);

    try {
      const response = await fetch(CLOUDINARY_URL, {
        method: 'POST',
        body: uploadFormData,
      });

      if (response.ok) {
        const data = await response.json();

        if (docType.startsWith("markSheet") || docType.startsWith("certificate")) {
          const isMarkSheet = docType.startsWith("markSheet");
          const section = isMarkSheet ? "markSheet" : "certificate";
          const fileNameKey = isMarkSheet ? "markSheetFileNames" : "certificateFileNames";

          setFormData((prevFormData) => ({
            ...prevFormData,
            [section]: {
              ...prevFormData[section],
              [`level${index + 1}`]: data.secure_url,
              [`level${index + 1}Progress`]: 100,
              [`level${index + 1}Status`]: 'Uploaded',
            },
            [fileNameKey]: {
              ...prevFormData[fileNameKey],
              [`level${index + 1}`]: file.name,
            }
          }));
        } else {
          setFormData((prevFormData) => ({
            ...prevFormData,
            [docType]: data.secure_url,
            [`${docType}Progress`]: 100,
            [`${docType}Status`]: 'Uploaded',
            [`${docType}FileName`]: file.name,
          }));
        }
        console.log(`${docType} uploaded successfully: ${data.secure_url}`);
      } else {
        toast.error('Error uploading file');
      }
    } catch (error) {
      toast.error('Error uploading file');
    } finally {
      setLoadingButton(null);
    }
  };

  // Function to convert first page of a PDF to JPG
  const convertPdfToJpg = async (pdfFile) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(pdfFile);

      reader.onload = async () => {
        const pdfData = new Uint8Array(reader.result);
        const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
        const page = await pdf.getPage(1);

        const scale = 2;
        const viewport = page.getViewport({ scale });
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        const renderContext = { canvasContext: context, viewport };
        await page.render(renderContext).promise;

        canvas.toBlob((blob) => {
          if (blob) resolve(blob);
          else reject("Error converting PDF page to image");
        }, "image/jpeg");
      };

      reader.onerror = (error) => reject(error);
    });
  };
  const resetUpload = (docType) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [`${docType}Progress`]: 0,
      [`${docType}Status`]: '',
      [`${docType}FileName`]: ''
    }));
  };


  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "nationality" || name === "countryBirth") {
  //     // Find the country object from the countriesList using the selected country name
  //     const selectedCountry = countriesList.find(
  //       (country) => country.name === value
  //     );

  //     // Store the country name directly in the formData
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [name]: selectedCountry ? selectedCountry.name : "", // Store the country name directly
  //     }));
  //   } else if (["studentName", "surname", "emergencyName"].includes(name)) {
  //     // Validate alphabetic characters for specific fields
  //     if (/^[A-Za-z\s]*$/.test(value)) {
  //       setFormData((prevData) => ({
  //         ...prevData,

  //         [name]: value,
  //       }));
  //     }
  //   } else {
  //     // For other fields, update the form data normally
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [name]: value,
  //     }));
  //   }
  // };



  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'proofType') {
      // Reset the nric field when switching between NRIC and FIN
      setFormData((prevData) => ({
        ...prevData,
        proofType: value,
        nric: '', // clear the previous NRIC/FIN value
      }));
      setError(''); // Clear error on proofType change
      return;
    }

    if (name === 'nric') {
      const upperValue = value.toUpperCase();
      const isValid = validateIdentityNumbers(formData.proofType, upperValue);

      setFormData((prevData) => ({
        ...prevData,
        [name]: upperValue,
      }));

      setError(
        upperValue ? (isValid ? '' : `Invalid ${formData.proofType} format`) : ''
      );
      return;
    }

    if (name === 'nationality' || name === 'countryBirth') {
      const selectedCountry = countriesList.find(
        (country) => country.name === value
      );
      setFormData((prevData) => ({
        ...prevData,
        [name]: selectedCountry ? selectedCountry.name : '',
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };



  const handleKnowAboutProgramChange = (event) => {
    const value = event.target.value;
    setFormData((prevData) => ({
      ...prevData,
      knowAboutProgram: value,
      otherDetails: value !== "other" ? "" : prevData.otherDetails, // Clear otherDetails if not "other"
    }));
  };
  const handleOtherDetailsChange = (event) => {
    setFormData((prevData) => ({
      ...prevData,
      otherDetails: event.target.value,
    }));
  };

  const handleReferalFriendChange = (event) => {
    setFormData((prevData) => ({
      ...prevData,
      referalfriend: event.target.value,
    }));
  };
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  const handleInstitutionChange = (index, e) => {
    const { name, value } = e.target;
    const newInstitutionDetails = formData.institutionDetails.map(
      (institution, i) => {
        if (i === index) {
          return { ...institution, [name]: value };
        }
        return institution;
      }
    );
    setFormData({
      ...formData,
      institutionDetails: newInstitutionDetails,
    });
  };

  const addInstitution = () => {
    setFormData({
      ...formData,
      institutionDetails: [
        ...formData.institutionDetails,
        {
          institution: "",
          // toYear: "",
          year: "",
          fullTimeOrPartTime: "",
          qualificationsAchieved: "",
        },
      ],
    });
  };

  const removeInstitution = (index) => {
    const newInstitutionDetails = formData.institutionDetails.filter(
      (_, i) => i !== index
    );
    setFormData({
      ...formData,
      institutionDetails: newInstitutionDetails,
    });
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   axios.post('/registrationadvances', formData)
  //     .then(response => {
  //       console.log("Full response: ", response);

  //       const { name, id: studentId } = response.data.student;
  //       const {id:id} = response.data;
  //       console.log("response.data", response.data);
  //       setStudentDetails({ name, studentId });
  //       setRegistrationadvance({id})

  //       setOpen(true); // Open the payment modal
  //     })
  //     .catch(error => {
  //       console.error("There was an error submitting the form!", error);
  //       toast.error("Error submitting the form. Please try again.");
  //     });
  // };

  //modified
  const handleSubmit = (e) => {
    e.preventDefault();


    // Prevent multiple submissions
    if (isSubmitting) return;

    if (!formData.workPermitSpass) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        workPermitSpass: "Please upload a file before submitting.",
      }));
      return;
    }

    setIsSubmitting(true);

    // Clear previous error messages for a successful submission
    setErrors((prevErrors) => ({
      ...prevErrors,
      workPermitSpass: "",
    }));

    console.log("check", formData);
    const filteredFormData = Object.keys(formData).reduce((acc, key) => {
      if (
        formData[key] !== "" &&
        formData[key] !== null &&
        formData[key] !== undefined
      ) {
        acc[key] = formData[key];
      }
      return acc;
    }, {});

    filteredFormData.markSheet = Object.keys(formData.markSheet).reduce(
      (acc, key) => {
        if (
          formData.markSheet[key] !== "" &&
          formData.markSheet[key] !== null &&
          formData.markSheet[key] !== undefined
        ) {
          acc[key] = formData.markSheet[key];
        }
        return acc;
      },
      {}
    );
    const nationalityValue = nationalityMapping[formData.nationality] || "";
    const submissionData = {
      ...formData,
      knowAboutProgram:
        formData.knowAboutProgram === "other"
          ? formData.otherDetails
          : formData.knowAboutProgram,
      knowAboutProgram:
        formData.knowAboutProgram === "referal"
          ? formData.referalfriend
          : formData.knowAboutProgram,
      nationality: nationalityValue,
    };
    console.log("before update", submissionData);

    axios
      .post("/registrationadvances", submissionData)
      .then((response) => {
        console.log("Full response: ", response);

        const { name, id: studentId } = response.data.student;
        const { id } = response.data;
        console.log("response.data", response.data);

        // setStudentDetails({ name, studentId });
        // setRegistrationadvance({ id });
        setSubmissionSuccess(true);

        setOpen(true); // Open the payment modal

        // Display success message
        toast.success("Form submitted successfully");

        // Add fade-out class to dialog

        // Navigate after 3 seconds
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch((error) => {
        console.error("There was an error submitting the form!", error);
        toast.error("Error submitting the form. Please try again.");
      })
  };


  const checkEmailExists = async (email) => {
    console.log(email + "email")
    try {
      const response = await axios.get(`/home/check-email`, {
        params: { email }
      });
      return response.data; // Assume backend returns { available: true } if email is not in use
    } catch (error) {
      console.error('Error checking email:', error);
      return false;
    }
  };


  const nextPage = async () => {
    if (
      !formData.studentName ||
      !formData.nric ||
      !formData.handPhone ||
      !formData.email ||
      !formData.gender ||
      !formData.dob ||
      !formData.password ||
      !formData.countryBirth ||
      !formData.nationality ||
      !formData.passportNo ||
      !formData.addressHome ||
      !formData.phoneHome
    ) {
      toast.error("Please fill in all required fields on Page 2.");
      return;
    }

    if (!validateEmail(formData.email)) {
      toast.error("Invalid email format on Page 2.");
      return;
    }

    if (!validatePassword(formData.password)) {
      toast.error("Password must be at least 8 characters on Page 2.");
      return;
    }

    if (!validatePassportNumber(formData.passportNo)) {
      toast.error(
        "Passport number must be alphanumeric and 8-9 characters long on Page 2."
      );
      return;
    }

    // Check if email already exists
    const emailAvailable = await checkEmailExists(formData.email);

    if (!emailAvailable) {
      toast.error('Email already exists');
      return;
    }

    setPage((prevPage) => prevPage + 1); // Proceed to next page if 404 error occurs
  };

  const prevPage = () => {
    setPage(page - 1);
  };

  const nextPagewithApi = async () => {
    const errorMessages = [];
    const requiredFields = [formData.studentName, formData.proofType];

    // Add NRIC/FIN field validation based on proofType
    if (formData.proofType === "NRIC" || formData.proofType === "FIN") {
      requiredFields.push(formData.nric);
    }

    const isFormValid = requiredFields.every(
      (field) => field && field.trim() !== ""
    );

    // Check NRIC format if proofType is NRIC
    const nricRegex = /^[STFGM][0-9]{7}[A-Z]$/;
    const finRegex = /^[STFGM][0-9]{7}[A-Z]$/;

    if (formData.proofType === "NRIC" && !nricRegex.test(formData.nric)) {
      toast.error("Invalid NRIC format");
      return;
    } else if (formData.proofType === "FIN" && !finRegex.test(formData.nric)) {
      toast.error("Invalid FIN format");
      return;
    }

    if (!formData.studentName || formData.studentName.trim() === "") {
      errorMessages.push("Student name is required");
    }

    if (!formData.batchId) {
      errorMessages.push("Please select a course");
    }

    if (!formData.enrollmentDate) {
      errorMessages.push("Enrollment date is required");
    }

    if (!formData.proofType) {
      errorMessages.push("ID type (NRIC/FIN) is required");
    }

    if (
      (formData.proofType === "NRIC" || formData.proofType === "FIN") &&
      !formData.nric
    ) {
      errorMessages.push(`${formData.proofType} number is required`);
    }

    // If there are error messages, display them using the toast and stop the function
    if (errorMessages.length > 0) {
      errorMessages.forEach((message) => {
        toast.error(message);
      });
      return;
    }

    // If all validations pass, move to the next page
    goToNextPage(); // Now this function is defined
  };

  const handleContinue = () => {
    setAlreadyRegistered(false); // Close the modal
    setFormData((prevData) => ({
      ...prevData,
      studentName: dataResponse?.name || prevData.studentName,
      nric: dataResponse?.nricno || prevData.nric,
      phone: dataResponse?.handPhone || prevData.phone,
      email: dataResponse?.email || prevData.email,
      gender: dataResponse?.gender || prevData.gender,
      dob: dataResponse?.dob || prevData.dob,
      // password: dataResponse.student.password || prevData.password,
      sureName: dataResponse?.sureName || prevData.sureName,
      countryBirth: dataResponse?.countryBirth || prevData.countryBirth,
      passportNo: dataResponse?.passportNo || prevData.passportNo,
      addressOffice: dataResponse?.addressOffice || prevData.addressOffice,
      addressHome: dataResponse?.addressHome || prevData.addressHome,
      phoneOffice: dataResponse?.phoneOffice || prevData.phoneOffice,
      phoneHome: dataResponse?.phoneHome || prevData.phoneHome,
      handPhone: dataResponse?.handPhone || prevData.handPhone,
      emergencyName: dataResponse?.emergencyName || prevData.emergencyName,
      emergencyRelation:
        dataResponse?.emergencyRelation || prevData.emergencyRelation,
      emergencyPhone: dataResponse?.emergencyPhone || prevData.emergencyPhone,
      knowAboutProgram:
        dataResponse?.knowAboutProgram || prevData.knowAboutProgram,
      applicationSignature:
        dataResponse?.applicationSignature || prevData.applicationSignature,
      nonSingaporean: dataResponse?.nonSingaporean || prevData.nonSingaporean,
      company: dataResponse?.company || prevData.company,
      institutionDetails: dataResponse?.institutionDetails.length > 0 ? dataResponse?.institutionDetails : prevData.institutionDetails,
      // institutionDetails: result.institutionDetails [] ,
    }));
    setPage((prevPage) => prevPage + 1);
  };

  const handleCloseModalforAlumni = () => {
    setAlreadyRegistered(false); // Close the modal
    setPage((prevPage) => prevPage + 1);
  };

  const handleCloseModal = () => {
    setAlreadyRegistered(false); // Close the modal
  };

  // const validatePhone = (value) => {
  //   // Example validation: Check if value is numeric and meets maxLength
  //   return /^\d+$/.test(value) && value.length === 8;
  // };

  const validateEmail = (value) => {
    // Example validation: Check if value is a valid email format
    return /\S+@\S+\.\S+/.test(value);
  };

  const validatePassword = (value) => {
    // Example validation: Check if value meets minimum length requirement
    return value.length >= 8;
  };

  const validatePassportNumber = (value) => {
    // Validate if value is alphanumeric and within specified length
    return /^[a-zA-Z0-9]{8,9}$/.test(value);
  };

  // const handleBatchChange = (event) => {
  //   const selectedBatchId = event.target.value;
  //   const selectedBatch = batchSummary.find(batch => batch.batchId === selectedBatchId);
  //   if (selectedBatch) {
  //     setFormData({
  //       ...formData,
  //       batchId: selectedBatch.id,
  //       startModulus: selectedBatch.currentModule,
  //       // enrollmentDate: selectedBatch.startDate,
  //       type: selectedBatch.type,
  //     });
  //   }
  //   console.log(formData.batchId);
  //   console.log(formData.startModulus);
  //   console.log(formData.type);
  //   setSelectedBatchId(selectedBatchId);
  // };

  // const handleDateChange = (e) => {
  //   //  handleDateChangeforenroll(e.target.value);
  //   const newDate = e.target.value;
  //   setFormData((prevFormData) => ({
  //     ...prevFormData,
  //     enrollmentDate: newDate,
  //   }));
  //   // Log the new value after state update
  //   console.log(newDate);
  // };

  // function calculateNextModule(currentModule, enrollmentDate, courseType) {
  //   const totalModules = 6; // Total number of modules in the course
  //   const currentDate = new Date();
  //   const currentMonth = currentDate.getMonth() + 1; // January = 1, February = 2, etc.

  //   if (courseType === "diploma") {
  //     // Increment the module for the next odd month
  //     const nextModule = (currentModule % totalModules) + 1;
  //     return nextModule;
  //   } else if (courseType === "advance diploma") {
  //     // For advanced diploma, modules change every month
  //     const monthsPassed =
  //       (currentDate.getFullYear() - new Date(enrollmentDate).getFullYear()) * 12 +
  //       (currentDate.getMonth() - new Date(enrollmentDate).getMonth());

  //     const nextModule = ((currentModule + monthsPassed) % totalModules) || totalModules;
  //     return nextModule;
  //   }
  // }
  // const handleDateChange = (event) => {
  //   // Get the new date from the event
  //   const { value } = event.target;
  //   console.log("Selected Enrollment Date:", value);

  //   const newDate = dayjs(value); // Create dayjs object from the new date
  //   const oldDate = dayjs(); // Get the current date

  //   console.log("Current Date:", oldDate.format('YYYY-MM-DD'));
  //   console.log("New Date:", newDate.format('YYYY-MM-DD'));

  //   // Calculate the difference in months between the old and new dates
  //   let monthDifference = newDate.month() - oldDate.month(); // Difference in months, taking months of the year into account

  //   if (newDate.year() !== oldDate.year()) {
  //     // Adjust for different years (e.g., from Dec to Jan)
  //     monthDifference += (newDate.year() - oldDate.year()) * 12;
  //   }

  //   console.log("Month Difference:", monthDifference);

  //   // Determine the increment based on the type
  //   let increment = 0;
  //   if (formData.type === 'diploma') {
  //     increment = Math.floor(monthDifference / 2); // Increment by 1 for every 2 months
  //     console.log("Diploma Course - Increment:", increment);
  //   }
  //   else if (formData.type === 'advance_diploma') {
  //     increment = monthDifference; // Increment by 1 for every month
  //     console.log("Advance Diploma Course - Increment:", increment);
  //   }

  //   // Calculate the new modulus value based on the increment
  //   let newModulus = initialModulus + increment;
  //   console.log("New Modulus Before Ensuring Range:", newModulus);

  //   // Ensure the modulus value stays between 1 and 6
  //   newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1; // Wrap around to keep it between 1 and 6
  //   console.log("New Modulus After Ensuring Range:", newModulus);

  //   // For advance diploma, check the first Sunday of the month
  //   const firstSunday = newDate.date(1).day(7); // Get the first Sunday of the month
  //   console.log("First Sunday of the Month:", firstSunday.format('YYYY-MM-DD'));

  //   // If newDate is after the first Sunday, increase the modulus by 1
  //   if (newDate.isAfter(firstSunday)) {
  //     newModulus += 1;
  //     console.log("Advance Diploma - Adjusting Modulus by adding 1.");
  //   }

  //   // Ensure modulus value stays within the 1-6 range after adjustments
  //   newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1;

  //   // Update the form data with the new values
  //   setFormData(prevFormData => ({
  //     ...prevFormData,
  //     enrollmentDate: value,
  //     startModulus: newModulus,
  //   }));

  //   console.log("Updated Form Data:", {
  //     ...formData,
  //     enrollmentDate: value,
  //     startModulus: newModulus,
  //   });
  // };

  // const handleDateChange = (event) => {
  //   // Get the new date from the event
  //   const { value } = event.target;
  //   console.log("Selected Enrollment Date:", value);

  //   const newDate = dayjs(value); // Create dayjs object from the new date
  //   const oldDate = dayjs(); // Get the current date

  //   console.log("Current Date:", oldDate.format('YYYY-MM-DD'));
  //   console.log("New Date:", newDate.format('YYYY-MM-DD'));

  //   // Calculate the difference in months between the old and new dates
  //   let monthDifference = newDate.month() - oldDate.month();
  //   if (newDate.year() !== oldDate.year()) {
  //     monthDifference += (newDate.year() - oldDate.year()) * 12;
  //   }
  //   console.log("Month Difference:", monthDifference);

  //   // Determine the increment based on the type
  //   let increment = 0;
  //   if (formData.type === 'diploma') {
  //     increment = Math.floor(monthDifference / 2);
  //     console.log("Diploma Course - Increment:", increment);
  //   } else if (formData.type === 'advance_diploma') {
  //     increment = monthDifference;
  //     console.log("Advance Diploma Course - Increment:", increment);
  //   }

  //   // Calculate the new modulus value based on the increment
  //   let newModulus = initialModulus + increment;
  //   newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1; // Wrap around to keep it between 1 and 6
  //   console.log("New Modulus Before Ensuring Range:", newModulus);

  //   // Determine the first Saturday and Sunday of the month
  //   const firstSaturday = newDate.date(1).day(6); // First Saturday
  //   const firstSunday = newDate.date(1).day(7);   // First Sunday

  //   console.log("First Saturday of the Month:", firstSaturday.format('YYYY-MM-DD'));
  //   console.log("First Sunday of the Month:", firstSunday.format('YYYY-MM-DD'));



  //   // Adjust modulus based on the type and day checks
  //   if (formData.type === 'diploma') {
  //     const isEvenMonth = (newDate.month() + 1) % 2 === 0; // Check if the month is even
  //     console.log("Is Even Month:", isEvenMonth);

  //     if (isEvenMonth) {
  //       // For even months, just add 1 to newModulus
  //       newModulus += 1;
  //       console.log("Diploma - Even Month: Adjusting Modulus by adding 1.");
  //     } else {
  //       // For odd months, check if the new date is after the first Saturday or Sunday
  //       if (newDate.isAfter(firstSaturday) || newDate.isAfter(firstSunday)) {
  //         newModulus += 1;
  //         console.log("Diploma - Odd Month: Adjusting Modulus by adding 1 after the first Saturday/Sunday.");
  //       }
  //     }
  //   } else if (formData.type === 'advance_diploma') {
  //     // Check if the new date is after the first Sunday
  //     if (newDate.isAfter(firstSunday)) {
  //       newModulus += 1;
  //       console.log("Advance Diploma - Adjusting Modulus by adding 1.");
  //     }
  //   }

  //   // Ensure modulus value stays within the 1-6 range after adjustments
  //   newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1;

  //   // Update the form data with the new values
  //   setFormData(prevFormData => ({
  //     ...prevFormData,
  //     enrollmentDate: value,
  //     startModulus: newModulus,
  //   }));
  //   console.log("newModulus:", newModulus);
  //   console.log("Updated Form Data:", {
  //     ...formData,
  //     enrollmentDate: value,
  //     startModulus: newModulus,
  //   });
  // };

  // const handleDateChange = (event) => {
  //   const { value } = event.target;
  //   console.log("Selected Enrollment Date:", value, "| Type:", typeof value);

  //   const newDate = dayjs(value);
  //   const oldDate = dayjs();

  //   console.log("Current Date:", oldDate.format('YYYY-MM-DD'));
  //   console.log("New Date:", newDate.format('YYYY-MM-DD'));
  //   console.log("New Date Valid?", newDate.isValid());

  //   // Check for invalid date handling
  //   if (!newDate.isValid()) {
  //     console.error("Invalid newDate detected. Check input format.");
  //     return;
  //   }

  //   let monthDifference = newDate.month() - oldDate.month();
  //   if (newDate.year() !== oldDate.year()) {
  //     monthDifference += (newDate.year() - oldDate.year()) * 12;
  //   }
  //   console.log("Month Difference:", monthDifference);

  //   console.log("Form Data Type:", formData?.type);

  //   let increment = 0;
  //   if (formData?.type === 'diploma') {
  //     // Check if the oldDate month is odd or even
  //     if (oldDate.month() % 2 === 1) {
  //       // For odd months, increment by 1 for every odd month difference
  //       increment = Math.floor((monthDifference + 1) / 2);
  //     } else {
  //       // For even months, increment by 1 for every 2 months
  //       increment = Math.floor(monthDifference / 2);
  //     }
  //     console.log("Diploma Course - Increment:", increment);
  //   } else if (formData?.type === 'advance_diploma') {
  //     // For advance diploma, increment by the full month difference
  //     increment = monthDifference;
  //     console.log("Advance Diploma Course - Increment:", increment);
  //   } else {
  //     console.warn("Unknown formData.type detected:", formData?.type);
  //   }

  //   console.log("Initial Modulus:", initialModulus);

  //   // Adjust the modulus based on the increment
  //   let newModulus = initialModulus + increment;
  //   newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1; // Ensure modulus stays within 1-6
  //   console.log("New Modulus After Adjustments:", newModulus);

  //   const firstDayOfMonth = newDate.date(1);

  //   const firstSaturday = firstDayOfMonth.day(6).isBefore(firstDayOfMonth)
  //     ? firstDayOfMonth.day(6 + 7)
  //     : firstDayOfMonth.day(6);


  //   const firstSunday = firstDayOfMonth.add((7 - firstDayOfMonth.day()) % 7, "day");

  //   console.log("First Saturday of the Month:", firstSaturday.format('YYYY-MM-DD'));
  //   console.log("First Sunday of the Month:", firstSunday.format('YYYY-MM-DD'));

  //   console.log("before updating  New Modulus:", newModulus);

  //   if (formData?.type === 'diploma') {
  //     const isEvenMonth = (newDate.month() + 1) % 2 === 0;
  //     console.log("Is Even Month:", isEvenMonth);

  //     if (isEvenMonth) {
  //       newModulus += 1;
  //       console.log("Diploma - Even Month: Adjusting Modulus by adding 1.");
  //     } else {
  //       if (newDate.isAfter(firstSaturday) || newDate.isAfter(firstSunday)) {
  //         newModulus += 1;
  //         console.log("Diploma - Odd Month: Adjusting Modulus by adding 1 after first Saturday/Sunday.");
  //       }
  //     }
  //   }
  //   else if (formData?.type === 'advance_diploma') {

  //     console.log((oldDate.month()), "oldDate");
  //     console.log((oldDate.month() + 1) % 2, "oldDate");
  //     if ((oldDate.month() + 1) % 2 === 1) {
  //       // For odd months, increment by 1 for every odd month difference
  //       if (newDate.isAfter(firstSunday)) {
  //         newModulus = newModulus;
  //         console.log("Advance Diploma - Adjusting Modulus by subtracting 1.", (oldDate.month()));
  //       }
  //       else {
  //         newModulus -= 1;
  //       }
  //     }
  //     else if ((oldDate.month() + 1) % 2 === 0) {
  //       if (newDate.isAfter(firstSunday)) {
  //         newModulus += 1;
  //         console.log("Advance Diploma - Adjusting Modulus by adding 1.", (oldDate.month()));

  //       }
  //       else {
  //         newModulus = newModulus;
  //         console.log("hiihih", (oldDate.month()));
  //       }
  //     }

  //   }

  //   newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1;
  //   console.log("Final New Modulus:", newModulus);

  //   setFormData(prevFormData => ({
  //     ...prevFormData,
  //     enrollmentDate: value,
  //     startModulus: newModulus,
  //   }));

  //   console.log("Updated Form Data:", {
  //     ...formData,
  //     enrollmentDate: value,
  //     startModulus: newModulus,
  //   });
  // };

  const handleDateChange = (event, selectedBatch) => {

    const { value } = event.target;
    console.log("Selected Enrollment Date:", value, "| Type:", typeof value);

    const newDate = dayjs(value);
    const currentDate = dayjs();

    const intakeStartDate = selectedBatch?.intakeStartDate ? dayjs(selectedBatch.intakeStartDate) : null;
    const isDatePassed = intakeStartDate && newDate.isAfter(intakeStartDate);


    console.log("Intake Start Date:", intakeStartDate?.format('YYYY-MM-DD'));
    console.log("Is Date Passed Intake Start Date?", isDatePassed);
    console.log("selectedBatch", selectedBatch);


    if (selectedBatch?.status && newDate.isBefore(currentDate, 'day') && intakeStartDate) {
      toast.error("Enrollment date cannot be before today.");
      return;
    } else if (selectedBatch?.status && isDatePassed) {
      toast.error("Batch is not started yet.");
      return;
    } else if (selectedBatch?.status && !isDatePassed) {
      console.log("Batch is active. Using current module:", selectedBatch?.currentModule);
      // Exit function
      setFormData(prevFormData => ({
        ...prevFormData,
        enrollmentDate: event.target.value,
        startModulus: selectedBatch.currentModule,
      }));
      return;
    }

    const oldDate = dayjs();

    console.log("Current Date:", oldDate.format('YYYY-MM-DD'));
    console.log("New Date:", newDate.format('YYYY-MM-DD'));
    console.log("New Date Valid?", newDate.isValid());

    // Check for invalid date handling
    if (!newDate.isValid()) {
      console.error("Invalid newDate detected. Check input format.");
      return;
    }

    let monthDifference = newDate.month() - oldDate.month();
    if (newDate.year() !== oldDate.year()) {
      monthDifference += (newDate.year() - oldDate.year()) * 12;
    }
    console.log("Month Difference:", monthDifference);

    console.log("Form Data Type:", formData?.type);

    let increment = 0;
    if (formData?.type === 'diploma') {
      // Check if the oldDate month is odd or even
      if (oldDate.month() % 2 === 1) {
        // For odd months, increment by 1 for every odd month difference
        increment = Math.floor((monthDifference + 1) / 2);
      } else {
        // For even months, increment by 1 for every 2 months
        increment = Math.floor(monthDifference / 2);
      }
      console.log("Diploma Course - Increment:", increment);
    } else if (formData?.type === 'advance_diploma') {
      // For advance diploma, increment by the full month difference
      increment = monthDifference;
      console.log("Advance Diploma Course - Increment:", increment);
    } else {
      console.warn("Unknown formData.type detected:", formData?.type);
    }

    console.log("Initial Modulus:", initialModulus);

    // Adjust the modulus based on the increment
    let newModulus = initialModulus + increment;
    newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1; // Ensure modulus stays within 1-6
    console.log("New Modulus After Adjustments:", newModulus);

    const firstDayOfMonth = newDate.date(1);

    const firstSaturday = firstDayOfMonth.day(6).isBefore(firstDayOfMonth)
      ? firstDayOfMonth.day(6 + 7)
      : firstDayOfMonth.day(6);


    const firstSunday = firstDayOfMonth.add((7 - firstDayOfMonth.day()) % 7, "day");

    console.log("First Saturday of the Month:", firstSaturday.format('YYYY-MM-DD'));
    console.log("First Sunday of the Month:", firstSunday.format('YYYY-MM-DD'));

    console.log("before updating  New Modulus:", newModulus);

    if (formData?.type === 'diploma') {
      const isEvenMonth = (newDate.month() + 1) % 2 === 0;
      console.log("Is Even Month:", isEvenMonth);

      if (isEvenMonth) {
        newModulus += 1;
        console.log("Diploma - Even Month: Adjusting Modulus by adding 1.");
      } else {
        if (newDate.isAfter(firstSaturday) || newDate.isAfter(firstSunday)) {
          newModulus += 1;
          console.log("Diploma - Odd Month: Adjusting Modulus by adding 1 after first Saturday/Sunday.");
        }
      }
    }
    else if (formData?.type === 'advance_diploma') {
      console.log((oldDate.month()), "oldDate");
      console.log((oldDate.month() + 1) % 2, "oldDate");
      if ((oldDate.month() + 1) % 2 === 1) {
        if (newDate.isAfter(firstSunday)) {
          newModulus += 1;
          console.log("Advance Diploma - Adjusting Modulus by adding 1.");
        }
      }


      else if ((oldDate.month() + 1) % 2 === 0) {
        if (newDate.isAfter(firstSunday)) {
          newModulus += 1;
          console.log("Advance Diploma - Adjusting Modulus by adding 1.", (oldDate.month()));
        }
        else {
          newModulus = newModulus;
          console.log("hiihih", (oldDate.month()));
        }
      }
    }

    newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1;
    console.log("Final New Modulus:", newModulus);

    setFormData(prevFormData => ({
      ...prevFormData,
      enrollmentDate: value,
      startModulus: newModulus,
    }));

    console.log("Updated Form Data:", {
      ...formData,
      enrollmentDate: value,
      startModulus: newModulus,
    });
  };


  const uniqueNationalities = Array.from(
    new Map(
      prioritizedCountriesList
        .filter((country) => nationalityMapping[country.name])
        .map((country) => [
          nationalityMapping[country.name], // key: nationality label
          country.name,                     // value: country name
        ])
    ).entries()
  ).map(([label, country]) => ({ label, country }));

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Container component="main" maxWidth="md">
      <Paper
        elevation={3}
        sx={{ padding: 4, marginTop: 9, marginBottom: "20px" }}
      >
        <Box display="flex" justifyContent="center" mb={2}>
          <img
            id="imglogo"
            src={logoImage}
            alt="logoImage"
            style={{ maxWidth: "100%", height: "auto" }} // Ensures the image scales properly
          />
        </Box>
        <Typography variant="h3" align="center" gutterBottom>
          <h4>New Student (Jurong Academy)</h4>
        </Typography>

        <form onSubmit={handleSubmit}>
          {page === 0 && (
            <Grid container spacing={3} justifyContent="center" >
              <Grid item xs={12} sm={6}>
                <Paper elevation={3} sx={{ padding: 4, marginTop: 2 }}>
                  <TextField
                    fullWidth
                    label="Full Name (as per NRIC/Work pass)"
                    name="studentName"
                    value={formData.studentName}
                    onChange={handleChange}
                    required
                    margin="normal"
                  />

                  <FormControl fullWidth margin="normal">
                    <InputLabel id="batch-label">Select Course</InputLabel>
                    <Select
                      labelId="batch-label"
                      label="Select Course"
                      name="batchId"
                      value={selectedBatchId}
                      onChange={(e) => {
                        const selectedBatchId = e.target.value;
                        setSelectedBatchId(selectedBatchId);
                        const selectedBatch = batchSummary.find(
                          (batch) => batch.id === selectedBatchId
                        );
                        if (selectedBatch) {
                          setInitialModulus(selectedBatch.currentModule)
                          setSelectedBatch(selectedBatch)
                          console.log("selectedBatch", selectedBatch)
                          console.log("ggg", selectedBatch.currentModule)
                          setFormData((prevFormData) => ({
                            ...prevFormData,
                            batchId: selectedBatch.id,
                            // startModulus: selectedBatch.startModulus,
                            // startModulus: selectedBatch.currentModule,
                            // enrollmentDate: selectedBatch.enrollmentDate,
                            type: selectedBatch.type,
                            enrollmentDate: "",
                          }));
                          // console.log(selectedBatch.id);
                          // console.log(selectedBatch.currentModule);
                          // console.log(selectedBatch.type);
                        }
                      }}
                      required
                    >
                      <MenuItem value="" disabled>
                        Select Course
                      </MenuItem>
                      {batchSummary.map((batch) => (
                        <MenuItem key={batch.id} value={batch.id}>
                          {removeBracketedText(batch.course)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <TextField
                    fullWidth
                    label="Enrollment Date"
                    type="date"
                    name="enrollmentDate"
                    value={formData.enrollmentDate || ""}
                    // onChange={handleDateChange}
                    onChange={(e) => handleDateChange(e, selectedBatch)}
                    required
                    InputLabelProps={{ shrink: true }}
                    disabled={!selectedBatchId}
                  />

                  <FormControl fullWidth margin="normal">
                    <InputLabel id="id-type-label">Select ID Type</InputLabel>
                    <Select
                      labelId="id-type-label"
                      label="Select ID Type"
                      name="proofType"
                      value={formData.proofType}
                      onChange={handleChange}
                      required
                    >
                      <MenuItem value="NRIC">NRIC</MenuItem>
                      <MenuItem value="FIN">FIN</MenuItem>
                    </Select>
                  </FormControl>

                  {formData.proofType === "NRIC" && (
                    <TextField
                      fullWidth
                      label="NRIC"
                      name="nric"
                      value={formData.nric}
                      onChange={handleChange}
                      required
                      margin="normal"
                      inputProps={{
                        maxLength: 9,
                      }}
                    />
                  )}

                  {formData.proofType === "FIN" && (
                    <TextField
                      fullWidth
                      label="FIN"
                      name="nric"
                      value={formData.nric}
                      onChange={handleChange}
                      required
                      margin="normal"
                      inputProps={{
                        maxLength: 9,
                      }}
                    />
                  )}
                  <br />

                  <Grid
                    container
                    justifyContent="space-between"
                    sx={{ marginTop: 3 }}
                  >
                    <Grid item>
                      {/* <Button variant="outlined" color="secondary" onClick={handleCancel}>
                        Cancel
                      </Button> */}
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={nextPagewithApi}
                        disabled={Boolean(error) || isSubmitting}
                      >
                        Next
                      </Button>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          )}

          {page === 1 && (
            <Container maxWidth="lg">
              <Box display="flex" justifyContent="center" mt={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Full Name (As per NRIC / work pass)"
                      name="studentName"
                      value={formData.studentName}
                      onChange={handleChange}
                      required
                      disabled
                      type="text"
                      inputProps={{ maxLength: 25 }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="NRIC/FIN"
                      name="nric"
                      value={formData.nric}
                      onChange={handleChange}
                      required
                      disabled
                      type="text"
                      inputProps={{ maxLength: 9 }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <div style={{ position: "relative", width: "100%" }}>
                      <label style={{
                        position: "absolute",
                        top: "-8px",
                        left: "12px",
                        fontSize: "0.8rem",
                        color: "grey",
                        backgroundColor: "white",
                        padding: "0 4px",
                        zIndex: 1,
                      }}>
                        Mobile Phone*
                      </label>
                      <PhoneInput
                        preferredCountries={["sg", "my", "in"]}
                        country={"sg"}
                        value={formData.handPhone}
                        onChange={(value, country) =>
                          setFormData({
                            ...formData,
                            handPhone: `+${country.dialCode} ${value.slice(country.dialCode.length)}`,
                          })
                        }
                        inputStyle={{
                          height: "55px",
                          width: "100%",
                          borderRadius: "5px",
                          paddingLeft: "45px",
                          fontSize: "1rem",
                        }}
                        dropdownStyle={{ width: "250px" }}
                      />
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      error={formData.email && !validateEmail(formData.email)}
                      helperText={
                        formData.email && !validateEmail(formData.email)
                          ? "Invalid email format"
                          : ""
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <FormControl fullWidth required>
                      <InputLabel>Gender</InputLabel>
                      <Select
                        name="gender"
                        value={formData.gender}
                        onChange={handleChange}
                        label="Gender"
                      >
                        <MenuItem value=""><em>Select</em></MenuItem>
                        <MenuItem value="Male">Male</MenuItem>
                        <MenuItem value="Female">Female</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Date of Birth"
                      name="dob"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      value={formData.dob}
                      onChange={handleChange}
                      required
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Password"
                      name="password"
                      type={showPassword ? 'text' : 'password'}
                      value={formData.password}
                      onChange={handleChange}

                      required
                      error={formData.password && !validatePassword(formData.password)}
                      helperText={
                        formData.password && !validatePassword(formData.password)
                          ? "Password must be at least 8 characters"
                          : ""
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={(e) => e.preventDefault()} // Prevent focus loss
                              edge="end"
                            >
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{

                        "input::-ms-reveal, input::-ms-clear": {
                          display: "none",
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <Autocomplete
                      options={prioritizedCountriesList}
                      getOptionLabel={(option) => option.name}
                      value={
                        prioritizedCountriesList.find(
                          (country) => country.name === formData.countryBirth
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        const value = newValue ? newValue.name : '';
                        setCountryBirthValid(!!value);
                        handleChange({
                          target: {
                            name: 'countryBirth',
                            value,
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Country of Birth"
                          required
                          fullWidth
                          error={!countryBirthValid}
                          helperText={!countryBirthValid ? 'Please select a valid country from the list' : ''}
                        />
                      )}
                      isOptionEqualToValue={(option, value) => option.name === value.name}
                      onBlur={() => {
                        const isValid = prioritizedCountriesList.some(
                          (country) => country.name === formData.countryBirth
                        );
                        setCountryBirthValid(isValid);
                      }}
                    />
                  </Grid>


                  <Grid item xs={12} sm={4}>
                    <Autocomplete
                      options={uniqueNationalities}
                      getOptionLabel={(option) => option.label}
                      value={
                        uniqueNationalities.find(
                          (item) => item.country === formData.nationality
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        const value = newValue ? newValue.country : '';
                        setNationalityValid(!!value);
                        handleChange({
                          target: {
                            name: 'nationality',
                            value,
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Nationality"
                          required
                          fullWidth
                          error={!nationalityValid}
                          helperText={!nationalityValid ? 'Please select a valid nationality from the list' : ''}
                        />
                      )}
                      isOptionEqualToValue={(option, value) => option.label === value.label}
                      onBlur={() => {
                        const isValid = uniqueNationalities.some(
                          (item) => item.country === formData.nationality
                        );
                        setNationalityValid(isValid);
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Passport Number"
                      name="passportNo"
                      value={formData.passportNo}
                      onChange={handleChange}
                      required
                      error={
                        formData.passportNo &&
                        !validatePassportNumber(formData.passportNo)
                      }
                      helperText={
                        formData.passportNo &&
                          !validatePassportNumber(formData.passportNo)
                          ? "Alphanumeric, 8-9 characters"
                          : ""
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Home Address"
                      name="addressHome"
                      value={formData.addressHome}
                      onChange={handleChange}
                      required
                      type="text"
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <div style={{ position: "relative", width: "100%" }}>
                      <label style={{
                        position: "absolute",
                        top: "-8px",
                        left: "12px",
                        fontSize: "0.8rem",
                        color: "grey",
                        backgroundColor: "white",
                        padding: "0 4px",
                        zIndex: 1,
                      }}>
                        Home Phone*
                      </label>
                      <PhoneInput
                        preferredCountries={["sg", "my", "in"]}
                        country={"sg"}
                        value={formData.phoneHome}
                        onChange={(value, country) =>
                          setFormData({
                            ...formData,
                            phoneHome: `+${country.dialCode} ${value.slice(country.dialCode.length)}`,
                          })
                        }
                        inputStyle={{
                          height: "55px",
                          width: "100%",
                          borderRadius: "5px",
                        }}
                        dropdownStyle={{ width: "250px" }}
                      />
                    </div>
                  </Grid>
                </Grid>
              </Box>
            </Container>
          )}


          {page === 2 && (
            <Grid container spacing={3} justifyContent="center" mt={1}>
              {/* Emergency Contact Section */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Emergency Contact Name"
                  name="emergencyName"
                  value={formData.emergencyName}
                  onChange={handleChange}
                  required
                  type="text"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth required>
                  <InputLabel id="emergency-relation-label">
                    Emergency Contact Relation
                  </InputLabel>
                  <Select
                    labelId="emergency-relation-label"
                    name="emergencyRelation"
                    value={formData.emergencyRelation}
                    onChange={handleChange}
                    required
                    label="Emergency Contact Relation"
                  >
                    <MenuItem value="Friends">Friends</MenuItem>
                    <MenuItem value="Colleague">Colleague</MenuItem>
                    <MenuItem value="Parents">Parents</MenuItem>
                    <MenuItem value="Others">Others</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              {formData.emergencyRelation === "Others" && (
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    name="emergencyOtherDetails"
                    label="Please Specify Relation Name"
                    value={formData.emergencyOtherDetails}
                    onChange={handleChange}
                  // margin="normal"
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <div style={{ position: "relative", width: "100%" }}>
                  <label
                    style={{
                      position: "absolute",
                      top: "-8px", // Always at the top
                      left: "12px",
                      fontSize: "0.8rem", // Smaller size for a floating-label effect
                      color: "grey", // Matches Material-UI's active label color
                      backgroundColor: "white",
                      padding: "0 4px", // Prevents overlap with input background
                      zIndex: 1,
                    }}
                  >
                    Emergency Contact number*
                  </label>
                  <PhoneInput

                    preferredCountries={["sg", "my", "in"]}
                    country={"sg"}
                    value={formData.emergencyPhone}
                    onChange={(value, country) =>
                      setFormData({
                        ...formData,
                        emergencyPhone: `+${country.dialCode} ${value.slice(
                          country.dialCode.length
                        )}`,
                      })
                    }
                    inputStyle={{
                      height: "55px",
                      width: "100%",
                      borderRadius: "5px",
                    }}
                    dropdownStyle={{
                      width: "250px",
                    }}
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth required>
                  <InputLabel id="know-about-program-label">
                    How Did You Know About the Program?
                  </InputLabel>
                  <Select
                    labelId="know-about-program-label"
                    name="knowAboutProgram"
                    value={formData.knowAboutProgram}
                    onChange={handleKnowAboutProgramChange}
                    required
                    label="How Did You Know About the Program?"
                  >
                    <MenuItem value="referral">Friends</MenuItem>
                    <MenuItem value="Jurong Academy Website">
                      Jurong Academy Website
                    </MenuItem>
                    <MenuItem value="Flyers">Flyers</MenuItem>
                    <MenuItem value="Newspaper Advertisement">
                      Newspaper Advertisement
                    </MenuItem>
                    <MenuItem value="other">Others</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} >
                {formData.knowAboutProgram === "other" && (

                  <TextField
                    fullWidth
                    name="otherDetails"
                    label="Please Specify"
                    value={formData.otherDetails}
                    onChange={handleOtherDetailsChange}
                  />

                )}
                {formData.knowAboutProgram === "referral" && (
                  <TextField
                    fullWidth
                    name="referalfriend"
                    label="Please Specify Name"
                    value={formData.referalfriend}
                    onChange={handleReferalFriendChange}
                  />
                )}
              </Grid>

              {/* <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  required
                />
              </Grid> */}

              {/* Company Details Section */}
              <Grid item xs={12}>
                <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 'bold' }}>
                  Company Details
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Company Name"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  required={formData.proofType === "FIN"}
                  type="text"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Designation"
                  name="designation"
                  value={formData.designation}
                  onChange={handleChange}
                  required={formData.proofType === "FIN"}
                  type="text"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Company Address"
                  name="addressOffice"
                  value={formData.addressOffice}
                  onChange={handleChange}
                  required={formData.proofType === "FIN"}
                  type="text"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <div style={{ position: "relative", width: "100%" }}>
                  <label
                    style={{
                      position: "absolute",
                      top: "-8px", // Always at the top
                      left: "12px",
                      fontSize: "0.8rem", // Smaller size for a floating-label effect
                      color: "grey", // Matches Material-UI's active label color
                      backgroundColor: "white",
                      padding: "0 4px", // Prevents overlap with input background
                      zIndex: 1,
                    }}
                  >
                    Company Contact number*
                  </label>
                  <PhoneInput

                    preferredCountries={["sg", "my", "in"]}
                    country={"sg"}
                    required={formData.proofType === "FIN"}
                    value={formData.phoneOffice}
                    onChange={(value, country) =>
                      setFormData({
                        ...formData,
                        phoneOffice: `+${country.dialCode} ${value.slice(
                          country.dialCode.length
                        )}`,
                      })
                    }
                    inputStyle={{
                      height: "55px",
                      width: "100%",
                      borderRadius: "5px",
                    }}
                    dropdownStyle={{
                      width: "250px",
                    }}
                  />
                </div>
              </Grid>

              {/* Educational Details Section */}
              <Grid item xs={12}>
                <Typography
                  variant="h5"
                  gutterBottom
                  align="center"
                  sx={{ fontWeight: 'bold' }}
                >
                  Educational Details
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Grid container justifyContent="flex-end">
                  <Button
                    variant="contained"
                    startIcon={<Add />}
                    onClick={addInstitution}

                    sx={{
                      backgroundColor: buttonBackgroundColor
                    }}
                  >
                    Add Qualification
                  </Button>
                </Grid>
              </Grid>

              {formData.institutionDetails.length > 0 &&
                formData.institutionDetails.map((institution, index) => (
                  <Grid container spacing={3} key={index}>
                    <Grid item xs={12}>
                      <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Education {index + 1}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Institution"
                        name="institution"
                        value={institution.institution}
                        onChange={(e) => handleInstitutionChange(index, e)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Year"
                        name="year"
                        value={institution.year}
                        onChange={(e) => handleInstitutionChange(index, e)}
                      />
                    </Grid>
                    {/* <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      label="To Year"
                      name="toYear"
                      value={institution.toYear}
                      onChange={(e) => handleInstitutionChange(index, e)}
                      required
                    />
                  </Grid> */}
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth>
                        <InputLabel id={`full-time-part-time-label-${index}`}>
                          Full Time or Part Time
                        </InputLabel>
                        <Select
                          labelId={`full-time-part-time-label-${index}`}
                          label="Full Time or Part Time"
                          name="fullTimeOrPartTime"
                          value={institution.fullTimeOrPartTime}
                          onChange={(e) => handleInstitutionChange(index, e)}
                        >
                          <MenuItem value="Full Time">Full Time</MenuItem>
                          <MenuItem value="Part Time">Part Time</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Qualifications Achieved"
                        name="qualificationsAchieved"
                        value={institution.qualificationsAchieved}
                        onChange={(e) => handleInstitutionChange(index, e)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Tooltip title="Remove Institution">
                        <Button
                          variant="contained"
                          sx={{
                            backgroundColor: "#dc3545", // Red color (Bootstrap Danger)
                            color: "white",
                            "&:hover": {
                              backgroundColor: "#c82333", // Darker shade for hover
                            },
                          }}
                          onClick={() => removeInstitution(index)}
                        >
                          Remove
                        </Button>
                      </Tooltip>
                    </Grid>
                  </Grid>
                ))}


              <Grid item xs={12}>
                <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 'bold' }}>
                  Documents Submission
                </Typography>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TableContainer
                    component={Paper}
                    style={{
                      marginBottom: "20px",
                      width: "100%",
                      overflowX: "auto",
                    }}
                  >
                    <Table aria-label="file upload table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Items</TableCell>
                          <TableCell>Documents (File Upload)</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>File Name</TableCell> {/* New column */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {formData.institutionDetails.map(
                          (institution, index) => (
                            <TableRow key={index}>
                              <TableCell>
                                Mark Sheet for {institution.institution}
                              </TableCell>
                              <TableCell>
                                <Button
                                  variant="contained"
                                  component="label"
                                  fullWidth
                                  sx={{
                                    backgroundColor: buttonBackgroundColor,
                                  }}
                                  // required
                                  onClick={() =>
                                    resetUpload(`markSheet-${index}`)
                                  }
                                >
                                  {loadingButton === `markSheet-${index}` ? (
                                    <CircularProgress size={24} color="inherit" />
                                  ) : (
                                    formData.markSheet[`level${index + 1}`] ? "Re-upload" : "Upload"
                                  )}
                                  <input
                                    type="file"
                                    name={`markSheet-${index}`}
                                    hidden
                                    accept=".jpg, .jpeg, .png, .pdf,.docx,"
                                    onChange={(e) =>
                                      handleFileUpload(
                                        e,
                                        `markSheet-${index}`,
                                        index
                                      )
                                    }
                                  />
                                  {formData.markSheet[
                                    `level${index + 1}Progress`
                                  ] > 0 &&
                                    formData.markSheet[
                                    `level${index + 1}Progress`
                                    ] < 100 && (
                                      <LinearProgress
                                        variant="determinate"
                                        value={
                                          formData.markSheet[
                                          `level${index + 1}Progress`
                                          ]
                                        }
                                        style={{ marginTop: "8px" }}
                                      />
                                    )}
                                </Button>
                                <span
                                  style={{
                                    fontSize: "0.80rem",
                                    color: "blue",
                                    marginTop: "8px",
                                  }}
                                >
                                  Supported file types pdf,doc,img,jpeg*
                                </span>
                              </TableCell>
                              <TableCell>
                                {formData.markSheet[`level${index + 1}Status`]}
                              </TableCell>
                              <TableCell>
                                {
                                  formData.markSheetFileNames[
                                  `level${index + 1}`
                                  ]
                                }
                              </TableCell>{" "}
                              {/* New cell */}
                            </TableRow>
                          )
                        )}
                        {formData.institutionDetails.map(
                          (institution, index) => (
                            <TableRow key={index}>
                              <TableCell>
                                Certificate for {institution.institution}
                              </TableCell>
                              <TableCell>
                                <Button
                                  variant="contained"
                                  component="label"
                                  fullWidth
                                  sx={{
                                    backgroundColor: buttonBackgroundColor,
                                  }}
                                  // required
                                  onClick={() =>
                                    resetUpload(`certificate-${index}`)
                                  }
                                >
                                  {loadingButton === `certificate-${index}` ? (
                                    <CircularProgress size={24} color="inherit" />
                                  ) : (
                                    formData.certificate[`level${index + 1}`] ? "Re-upload" : "Upload"
                                  )}
                                  <input
                                    type="file"
                                    name={`certificate-${index}`}
                                    hidden
                                    accept=".jpg, .jpeg, .png, .pdf,.docx"
                                    onChange={(e) =>
                                      handleFileUpload(
                                        e,
                                        `certificate-${index}`,
                                        index
                                      )
                                    }
                                  />
                                  {formData.certificate[
                                    `level${index + 1}Progress`
                                  ] > 0 &&
                                    formData.certificate[
                                    `level${index + 1}Progress`
                                    ] < 100 && (
                                      <LinearProgress
                                        variant="determinate"
                                        value={
                                          formData.certificate[
                                          `level${index + 1}Progress`
                                          ]
                                        }
                                        style={{ marginTop: "8px" }}
                                      />
                                    )}
                                </Button>
                                <span
                                  style={{
                                    fontSize: "0.80rem",
                                    color: "blue",
                                    marginTop: "8px",
                                  }}
                                >
                                  Supported file types pdf,doc,img,jpeg*
                                </span>
                              </TableCell>
                              <TableCell>
                                {
                                  formData.certificate[
                                  `level${index + 1}Status`
                                  ]
                                }
                              </TableCell>
                              <TableCell>
                                {
                                  formData.certificateFileNames[
                                  `level${index + 1}`
                                  ]
                                }
                              </TableCell>{" "}
                              {/* New cell */}
                            </TableRow>
                          )
                        )}
                        <TableRow>
                          <TableCell>NRIC/Work Permit</TableCell>
                          <TableCell>
                            {/* Upload for workPermitSpass */}
                            <Button
                              variant="contained"
                              component="label"
                              sx={{
                                backgroundColor: buttonBackgroundColor,
                              }}
                              fullWidth
                              required
                              onClick={() => resetUpload("workPermitSpass")}
                            >
                              {loadingButton === "workPermitSpass" ? (
                                <CircularProgress size={24} color="inherit" />
                              ) : (
                                formData.workPermitSpass ? "Re-upload Work Permit front" : "Upload Work Permit front"
                              )}
                              <input
                                type="file"
                                name="workPermitSpass"
                                hidden
                                accept=".jpg, .jpeg, .png, .pdf,.docx,"
                                onChange={(e) =>
                                  handleFileUpload(e, "workPermitSpass")
                                }
                              />
                              {formData.workPermitSpassProgress > 0 &&
                                formData.workPermitSpassProgress < 100 && (
                                  <LinearProgress
                                    variant="determinate"
                                    value={formData.workPermitSpassProgress}
                                    style={{ marginTop: "8px" }}
                                  />
                                )}
                            </Button>

                            <Button
                              variant="contained"
                              component="label"
                              sx={{
                                backgroundColor: buttonBackgroundColor,
                              }}
                              fullWidth
                              required
                              style={{ marginTop: "10px" }}
                              onClick={() => resetUpload("workPermitOne")}
                            >
                              {loadingButton === "workPermitOne" ? (
                                <CircularProgress size={24} color="inherit" />
                              ) : (
                                formData.workPermitOne ? "Re-upload Work Permit back" : "Upload Work Permit back"
                              )}
                              <input
                                type="file"
                                name="workPermitOne"
                                hidden
                                accept=".jpg, .jpeg, .png, .pdf,.docx,"
                                onChange={(e) =>
                                  handleFileUpload(e, "workPermitOne")
                                }
                              />
                              {formData.workPermitOneProgress > 0 &&
                                formData.workPermitOneProgress < 100 && (
                                  <LinearProgress
                                    variant="determinate"
                                    value={formData.workPermitOneProgress}
                                    style={{ marginTop: "8px" }}
                                  />
                                )}
                            </Button>

                            <span
                              style={{
                                fontSize: "0.80rem",
                                color: "blue",
                                marginTop: "8px",
                                display: "block",
                              }}
                            >
                              Supported file types: pdf, doc, img, jpeg*
                            </span>

                            {errors.workPermitSpass && (
                              <span
                                style={{
                                  color: "red",
                                  fontSize: "0.80rem",
                                  marginTop: "8px",
                                }}
                              >
                                Please upload the Work Permit front file before
                                submitting.
                              </span>
                            )}
                            {errors.workPermitOne && (
                              <span
                                style={{
                                  color: "red",
                                  fontSize: "0.80rem",
                                  marginTop: "8px",
                                }}
                              >
                                Please upload the Work Permit back file before
                                submitting.
                              </span>
                            )}
                          </TableCell>

                          <TableCell>
                            {formData.workPermitSpassStatus && (
                              <div>{formData.workPermitSpassStatus}</div>
                            )}
                            {formData.workPermitOneStatus && (
                              <div>{formData.workPermitOneStatus}</div>
                            )}
                          </TableCell>

                          <TableCell>
                            {formData.workPermitSpassFileName && (
                              <div>{formData.workPermitSpassFileName}</div>
                            )}
                            {formData.workPermitOneFileName && (
                              <div>{formData.workPermitOneFileName}</div>
                            )}
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>Passport</TableCell>
                          <TableCell>
                            <Button
                              variant="contained"
                              component="label"
                              fullWidth
                              sx={{
                                backgroundColor: buttonBackgroundColor,
                              }}
                              // required
                              onClick={() => resetUpload("passport")}
                            >
                              {loadingButton === "passport" ? (
                                <CircularProgress size={24} color="inherit" />
                              ) : (
                                formData.passport ? "Re-upload" : "Upload"
                              )}                              <input
                                type="file"
                                name="passport"
                                hidden
                                onChange={(e) =>
                                  handleFileUpload(e, "passport")
                                }
                              />
                              {formData.passportProgress > 0 &&
                                formData.passportProgress < 100 && (
                                  <LinearProgress
                                    variant="determinate"
                                    value={formData.passportProgress}
                                    style={{ marginTop: "8px" }}
                                  />
                                )}
                            </Button>
                            <span
                              style={{
                                fontSize: "0.80rem",
                                color: "blue",
                                marginTop: "8px",
                              }}
                            >
                              Supported file types pdf,doc,img,jpeg*
                            </span>
                          </TableCell>
                          <TableCell>{formData.passportStatus}</TableCell>
                          <TableCell>
                            {formData.passportFileName}
                          </TableCell>{" "}
                          {/* New cell */}
                        </TableRow>

                        <TableRow>
                          <TableCell>Passport Size Photo</TableCell>
                          <TableCell>
                            <Button
                              variant="contained"
                              component="label"
                              fullWidth
                              sx={{
                                backgroundColor: buttonBackgroundColor,
                              }}
                              onClick={() => resetUpload("profilePicture")}
                            >
                              {loadingButton === "profilePicture" ? (
                                <CircularProgress size={24} color="inherit" />
                              ) : (
                                formData.profilePicture ? "Re-upload" : "Upload"
                              )}                              <input
                                type="file"
                                name="profilePicture"
                                hidden
                                accept=".jpg, .jpeg, .png ,.pdf"
                                onChange={(e) => handleFileUpload(e, "profilePicture")}
                              />
                              {formData.profilePictureProgress > 0 &&
                                formData.profilePictureProgress < 100 && (
                                  <LinearProgress
                                    variant="determinate"
                                    value={formData.profilePictureProgress}
                                    style={{ marginTop: "8px" }}
                                  />
                                )}
                            </Button>
                            <span style={{ fontSize: "0.80rem", color: "blue", marginTop: "8px" }}>
                              Supported file types: jpg, jpeg, png*,.pdf
                            </span>
                          </TableCell>
                          <TableCell>{formData.profilePictureStatus}</TableCell>
                          <TableCell>{formData.profilePictureFileName}</TableCell>
                        </TableRow>


                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
            </Grid>
          )}
          <Grid container spacing={2} sx={{ marginTop: 3 }}>
            {page === 1 && (
              <>
                <Grid item xs={6}>
                  <Button variant="outlined" onClick={prevPage} fullWidth>
                    Previous
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button variant="contained" onClick={nextPage} fullWidth sx={{
                    backgroundColor: buttonBackgroundColor,
                    color: 'white',
                  }}>
                    Next
                  </Button>
                </Grid>
              </>
            )}
            {page === 2 && (
              <>
                <Grid item xs={6}>
                  <Button variant="outlined" onClick={prevPage} fullWidth>
                    Previous
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    disabled={isSubmitting} // <-- disable when submitting
                    sx={{
                      backgroundColor: buttonBackgroundColor,
                    }}
                  >
                    Submit
                  </Button>
                </Grid>
              </>
            )}
          </Grid>
        </form>

        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          maxWidth="sm"
          PaperProps={{ style: { borderRadius: 15, overflow: "hidden" } }}
        >
          <DialogContent>
            {submissionSuccess ? (
              <Slide
                direction="up"
                in={submissionSuccess}
                mountOnEnter
                unmountOnExit
              >
                <Box textAlign="center" py={4}>
                  <CheckCircleIcon style={{ fontSize: 60, color: "green" }} />
                  <Typography variant="h5" gutterBottom>
                    Form Submitted Successfully!
                  </Typography>
                  <Typography variant="body1" color="textSecondary">
                    You will be redirected to the home page shortly.
                  </Typography>
                </Box>
              </Slide>
            ) : (
              <Box textAlign="center" py={4}>
                <CircularProgress />
                <Typography variant="h6" style={{ marginTop: 20 }}>
                  Submitting Your Form...
                </Typography>
              </Box>
            )}
          </DialogContent>
        </Dialog>
      </Paper>

      {/* Modal component for already registered */}
      <Modal
        open={alreadyRegistered}
        onClose={handleCloseModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 300,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
        >
          {editedStudent ? (
            <>
              <Typography id="modal-title" variant="h6" component="h2">
                Welcome back
              </Typography>
              <Button
                onClick={handleContinue}
                variant="contained"
                color="primary"
                fullWidth
              >
                continue
              </Button>
              <Button
                onClick={handleCloseModalforAlumni}
                variant="contained"
                color="primary"
                fullWidth
              >
                Cancel
              </Button>
            </>
          ) : (
            <>
              <Typography id="modal-title" variant="h6" component="h2">
                You are Already Active Student
              </Typography>
              <Button
                onClick={handleCloseModal}
                variant="contained"
                color="primary"
                fullWidth
              >
                Close
              </Button>
            </>
          )}
        </Box>
      </Modal>

      <ToastContainer />
    </Container>
    // </div >
  );
};

const NewStudenth = () => {
  return (
    <div>
      {/* <NavigationButtons /> */}
      <NewStudent />
    </div>
  );
};
export default NewStudenth;
